import { createStyles } from "antd-style";

const useMainScreenStyles = createStyles(({ css, prefixCls, token }) => {
  return {
    wrapper: css`
      position: relative;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        var(--Global-token-Primary-colorPrimary, #1677ff) 0%,
        var(--Global-token-Primary-colorPrimary, #1677ff) 20%,
        var(--Layout-Layout-bodyBg, #f5f5f5) 20%,
        var(--Layout-Layout-bodyBg, #f5f5f5) 100%
      );

      scrollbar-width: thin;

      .branchLogo {
        width: 76px;
        height: 76px;
        position: absolute;
        z-index: 2;
        top: 18px;
        left: calc(50% - 76px / 2);
        border: 1.9px solid var(--Global-token-Primary-colorPrimary, #1677ff);
        border-radius: 37.999px;
      }
    `,

    body: css`
      display: flex;
      gap: 8;
      padding: 0;
      flex-direction: column;
      height: 100%;
      gap: 16px;
      background: linear-gradient(
        180deg,
        var(--Global-token-Primary-colorPrimary, #1677ff) 0%,
        var(--Global-token-Primary-colorPrimary, #1677ff) 20%,
        var(--Layout-Layout-bodyBg, #f5f5f5) 20%,
        var(--Layout-Layout-bodyBg, #f5f5f5) 100%
      );
      margin-top: 68px;
      position: relative;
    `,

    content: css`
      width: 100%;
      border-radius: var(--Global-token-Radius-radiusXL, 24px);
      background: var(--Global-token-Bg-colorBgBase, #fff);
      padding: var(--Global-token-Padding-paddingXL, 32px) var(--Global-token-Padding-padding, 16px)
        var(--Global-token-Padding-padding, 16px) var(--Global-token-Padding-padding, 16px);

      display: flex;
      gap: 16;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex: 1 0;

      .${prefixCls}-card-body {
        width: 100%;
        padding: 0;
        display: flex;
        flex-direction: column;
        flex: 1 0;
        gap: 16px;
      }

      .branchTitle {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Large Title/Semibold */
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 28.8px */
      }

      .infoText {
        display: flex;
        align-items: center;
        gap: 8;

        padding: var(--Global-token-Padding-paddingS, 8px) var(--Global-token-Padding-padding, 16px);
        border-radius: var(--Global-token-Radius-radiusSM, 8px);
        background: var(--Global-token-Primary-colorPrimaryBg, #e6f4ff);

        span {
          color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
          text-align: center;
          font-feature-settings: "liga" off, "clig" off;

          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 120%; /* 15.6px */
        }
      }

      .callButton {
        color: var(--Global-token-Primary-colorPrimaryText, #1677ff);
        font-feature-settings: "liga" off, "clig" off;
        height: 32px;
        overflow-y: hidden;
        /* MD/Callout/Semibold */
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 15.6px */
        height: 32px;
        padding: var(--General-Button-paddingBlockXS, 8px) var(--General-Button-paddingInlineSM, 12px) !important;
        border-radius: var(--Global-token-Border-borderRadius, 8px);
      }
      .waButton {
        color: var(--Global-token-Success-colorSuccess, #52c41a);
        font-feature-settings: "liga" off, "clig" off;
        height: 32px;
        overflow-y: hidden;

        /* MD/Callout/Semibold */
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 15.6px */
        height: 32px;
        padding: var(--General-Button-paddingBlockXS, 8px) var(--General-Button-paddingInlineSM, 12px) !important;
        border-radius: var(--Global-token-Border-borderRadius, 8px);

        border-color: var(--Global-token-Success-colorSuccess, #52c41a);

        &:hover {
          background-color: var(--green-green-2);
        }
      }
      .chooseBtn {
        width: 100%;
        border-radius: var(--Global-token-Radius-radius, 12px);
        background: var(--Data-Display-Table-colorTabBg, #f5f5f5);
        padding: var(--Global-token-Padding-paddingS, 8px);
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        &:hover {
          background-color: var(--neutral-gray-5);
        }

        &:active {
          background-color: var(--neutral-gray-6);
        }
      }

      .specialtyIcon {
        display: flex;
        width: 32px;
        height: var(--Global-token-Control-controlHeightXXS, 32px);
        flex-direction: column;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1/1;
        padding: 2.5px 1.664px 2.5px 1.667px;

        border-radius: var(--Global-token-Radius-radiusSM, 8px);
        background: var(--Global-token-Primary-colorPrimary, #1677ff);
      }
      .arrowRight {
        margin-left: auto;
        padding: 6px 9px;
      }
    `,
    schedule: css`
      width: 100%;
      height: 322px;
      min-height: 322px;
      border-radius: 16px;
      background: var(--neutral-gray-3);

      .${prefixCls}-card-body {
        padding: 1rem 1.5rem;
      }
    `,
    weekDays: css`
      width: 100%;
      gap: 0.75rem;
    `,
    weekdayText: css`
      font-size: 1.0625rem;
      line-height: 120%;
      font-weight: 400;
      margin: 0;
    `,
    weekend: css`
      color: ${token.colorErrorText};
    `,
    weekDayDivider: css`
      margin: 0.75rem 0 0 0;
    `,

    footer: css`
      border-radius: var(--Global-token-Radius-radiusXL, 24px) var(--Global-token-Radius-radiusXL, 24px) 0 0;
      background: var(--Global-token-Bg-colorBgBase, #fff);
      padding: 8px 16px;
    `,
  };
});
export default useMainScreenStyles;
